var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "47px",
    viewBox: "0 0 61 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pixagri",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Aide-5",
    transform: "translate(-1037.000000, -554.000000)",
    stroke: "#9EBE4A",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1067.894375, 577.747922) rotate(-76.000000) translate(-1067.894375, -577.747922) translate(1052.465103, 552.972016)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line-21",
    strokeLinejoin: "round",
    transform: "translate(25.439764, 5.358922) rotate(-37.000000) translate(-25.439764, -5.358922) ",
    points: "21.4397639 1.66304078 29.4397639 1.66304078 29.4397639 9.05480399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18525777e-12,49.5518121 C11.8386145,41.1280147 20.6719479,24.6870448 26.5,0.228902349",
    id: "Line-8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBottom);
export default __webpack_public_path__ + "static/media/arrow_right_bottom.21666e63.svg";
export { ForwardRef as ReactComponent };